import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import SidebarList from './SidebarList';
import SidebarUpdate from './SidebarUpdate';

@inject(
    'loginStore',
    'CmsLanguageStore',
    'CmsSidebarStore'
)
@observer
class SidebarPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.CmsSidebarStore.getAll();
        this.props.CmsLanguageStore.getActives();
    }

    componentWillUnmount() {
        this.props.CmsSidebarStore.setshowModal(false);
    }

    cancelModal = () => {
        this.props.CmsSidebarStore.setshowModal(false);
    }

    render() {
        const {
            showModal,
            modalTitle
        } = this.props.CmsSidebarStore;

        return (
            <MainContainer title='Compendium Management' menukey='sidebars'>
                <Modal
                    title={modalTitle}
                    visible={showModal}
                    width={800}
                    footer={null}
                    onCancel={this.cancelModal}
                    zIndex={1000}
                >
                    <SidebarUpdate />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <SidebarList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default SidebarPage